window.addEventListener('DOMContentLoaded', (event) => {

    const elSlider = document.querySelectorAll("[data-carusel]");
    let ind = 1;
    elSlider.forEach(function(el:any) {
        //console.log('elSlider el: ',el);
        const dataCarusel = el.getAttribute("data-carusel");
        if(dataCarusel === "mobile") {
            //console.log('elSlider mobile el: ',el);
            const caruselID = "data-carusel-" + ind++;
            el.parentElement.setAttribute("data-carusel-mode", "mobile");
            el.setAttribute("id", caruselID);

            const leftStr = el.style.left.replace("px", "");
            const left = parseInt(leftStr);
            checkArrows(el, left);
            //el.nextSibling.style.display = 'flex';//show right arrow
            el.addEventListener('touchstart', handleTouchStart, false);
            el.addEventListener('touchmove', handleTouchMove, false);


        }

    });


    var xDown:any = null;
    var yDown:any = null;

    function getTouches(evt:any) {
        return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
    }

    function handleTouchStart(evt:any) {
        const firstTouch = getTouches(evt)[0];
        xDown = firstTouch.clientX;
        yDown = firstTouch.clientY;
    };

    function handleTouchMove(evt:any) {

        if ( ! xDown || ! yDown ) {
            return;
        }
        const speed = 6;

        const carouselElement : any = document.querySelectorAll("[data-carusel]")[0];

        const leftStr = carouselElement.style.left.replace("px", "");
        const left = parseInt(leftStr);
        checkArrows(carouselElement, left);
        //const carouselLimitWidth = (carouselElement.offsetWidth - window.screen.width);

        const xUp = evt.touches[0].clientX;
        const yUp = evt.touches[0].clientY;

        const xDiff = xDown - xUp;
        const yDiff = yDown - yUp;

        if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
            if ( xDiff > 0 ) {
                /* left swipe */
                if(Math.abs(left) >= (carouselElement.offsetWidth - carouselElement.parentElement.offsetWidth) ) {
                    return;
                }
                carouselElement.style.left = (left - 5*(speed/5)) + 'px';

            } else {
                /* right swipe */
                if(left >= 0) {
                    return;
                }

                carouselElement.style.left = (left + 10*(speed/5)) + 'px';
            }
        } else {
            if ( yDiff > 0 ) {
                /* down swipe */
            } else {
                /* up swipe */
            }
        }
        /* reset values */
        //xDown = null;
        //yDown = null;
        xDown = evt.touches[0].clientX;
        yDown = evt.touches[0].clientY;
    };
    function checkArrows(carouselElement: any, left:number){
        if(isNaN(left) ){
            //console.log(`1.left: ${left}, caruselLimit:${carouselElement.offsetWidth - window.screen.width}`);
            return;
        }
        const arrowLeft_Arr:any = carouselElement.parentElement.getElementsByClassName("arr-left");
        const arrowRight_Arr:any = carouselElement.parentElement.getElementsByClassName("arr-right");
        const arrowLeft:any = arrowLeft_Arr.length > 0 ? arrowLeft_Arr[0] : null;
        const arrowRight:any =arrowRight_Arr.length > 0 ? arrowRight_Arr[0] : null;

        //console.log(`2.left: ${left}, caruselLimit:${carouselElement.offsetWidth - window.screen.width}`);

        if(arrowLeft && arrowRight)
        {
            if(left >= 0)
                arrowLeft.style.display = 'none';
            //else
            //left row is hide
            //arrowLeft.style.display = 'flex';

            if(Math.abs(left) >= (carouselElement.offsetWidth - window.screen.width - 20) )
                arrowRight.style.display = 'none';
            else
                arrowRight.style.display = 'flex';
        }
    }

});




export {};